import type { CountryCode } from 'libphonenumber-js';

import { Box } from '../../../Box/Box';
import { flagStyle } from './styles.css';

export const Flag = ({ countryCode }: { countryCode: CountryCode }) => {
  const countryCodeLower = countryCode.toLowerCase();
  return (
    <Box display="flex" justifyContent="center" alignItems="center" className={flagStyle({ size: 'small' })}>
      <img
        style={{ width: '100%', height: '100%' }}
        src={`https://flagcdn.com/w80/${countryCodeLower}.png`}
        alt={countryCode}
      />
    </Box>
  );
};
